import { PlugToken } from '../interfaces/common'

export const getFeeToken = (token: PlugToken, tokens: PlugToken[]) => {
  if (token.fee_token_id) {
    return tokens.find((t) => t.id === token.fee_token_id)!
  } else if (token.evmChain?.feeTokenId) {
    const feeTokenId = token.evmChain.feeTokenId
    return tokens.find((t) => t.id === feeTokenId)!
  } else {
    return token
  }
}
